// extracted by mini-css-extract-plugin
export default {"block":"Jk","flex":"Kk","radio":"Lk","label":"Mk","error":"Nk","extra":"Ok"};